import Link from 'next/link';
import type { Recipe } from '@/types/recipe';

const catColors: Record<string, string> = {
  frokost: 'bg-amber-100 text-amber-700',
  lunsj: 'bg-sky-100 text-sky-700',
  middag: 'bg-violet-100 text-violet-700',
  snack: 'bg-green-100 text-green-700',
  dessert: 'bg-pink-100 text-pink-700',
  guide: 'bg-stone-100 text-stone-700',
};

export function RecipeCard({ recipe }: { recipe: Recipe }) {
  return (
    <Link href={`/oppskrifter/${recipe.slug}`} className="group block bg-white border border-stone-200 rounded-2xl overflow-hidden hover:shadow-md transition-all">
      {/* Image placeholder */}
      <div className="aspect-[4/3] bg-stone-100 relative overflow-hidden">
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img src={recipe.images.hero} alt={recipe.images.alt} className="w-full h-full object-cover" loading="lazy" />
        <div className="absolute top-3 left-3">
          <span className={`text-xs px-2 py-1 rounded-full font-medium ${catColors[recipe.category] || catColors.guide}`}>
            {recipe.category.charAt(0).toUpperCase() + recipe.category.slice(1)}
          </span>
        </div>
      </div>

      {/* Content */}
      <div className="p-4">
        <h3 className="font-semibold text-stone-900 text-sm group-hover:text-stone-600 transition-colors mb-1">{recipe.name}</h3>
        <div className="flex items-center gap-3 text-xs text-stone-400 mb-3">
          <span>{recipe.totalTimeMin} min</span>
          <span>{recipe.servings} porsjoner</span>
        </div>
        <div className="flex gap-2 text-xs">
          <span className="bg-stone-100 text-stone-600 px-2 py-1 rounded-lg">{recipe.nutrition.calories} kcal</span>
          <span className="bg-blue-50 text-blue-600 px-2 py-1 rounded-lg">P {recipe.nutrition.protein}g</span>
          <span className="bg-amber-50 text-amber-600 px-2 py-1 rounded-lg">K {recipe.nutrition.carbs}g</span>
          <span className="bg-red-50 text-red-600 px-2 py-1 rounded-lg">F {recipe.nutrition.fat}g</span>
        </div>
      </div>
    </Link>
  );
}
